import { LogOut } from "lucide-react";

export default function DashboardHero({ label, title, subtitle, onLogout, logoutTestId, icon: Icon, children }) {
  return (
    <div className="relative overflow-hidden rounded-3xl bg-[#144F75] p-7 md:p-9 mb-8">
      <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: "radial-gradient(circle at 15% 30%, #fff 1px, transparent 1px)", backgroundSize: "26px 26px" }} />
      <div className="relative flex items-start justify-between flex-wrap gap-4">
        <div>
          <p className="text-xs tracking-[0.2em] uppercase font-semibold text-[#D98E73] mb-2">{label}</p>
          <h1 className="font-serif text-3xl md:text-4xl text-white tracking-tight flex items-center gap-2.5">
            {Icon && <Icon size={26} className="text-[#D98E73]" />}{title}
          </h1>
          {subtitle && <p className="text-white/75 mt-2 max-w-xl text-sm leading-relaxed">{subtitle}</p>}
        </div>
        {onLogout && (
          <button onClick={onLogout} data-testid={logoutTestId} className="inline-flex items-center gap-1.5 text-sm rounded-full bg-white/10 text-white px-4 py-2 hover:bg-white/20 transition-colors">
            <LogOut size={15} /> Log out
          </button>
        )}
      </div>
      {children}
    </div>
  );
}
